<!--
    高级编辑器-帮助向导明细
    作用：提供向导步骤；
    实现：通过guideStep进步处理；
    组件：无
    注释：WJ
-->
<template>
    <div class="guide-box"
         :class="{
            first: ['first'].includes(guideStep),
            second: ['second'].includes(guideStep),
            four: ['four'].includes(guideStep),
         }"
    >
        <span class="angle"
            :class="{
                left: ['first'].includes(guideStep),
                right: ['second'].includes(guideStep)
            }"
        ></span>
        <div
            v-if="['start'].includes(guideStep)"
            class="guide-step">
            <p class="img"><img :src="$images.guide.start" alt="img"></p>
            <p class="content">老师您好：欢迎进入课件编辑器，让我带您简单认识一下功能吧！</p>
            <p class="btns">
                <span class="btn ignore" @click="handlerDone">跳 过</span>
                <span class="btn ok" @click="handlerNext('first')">好 的</span>
            </p>
        </div>
        <div
            v-if="['first'].includes(guideStep)"
            class="guide-step">
            <p class="img"><img :src="$images.guide.first" alt="img"></p>
            <p class="content">左侧为课件导航，可以根据做课思路或教学环节设定导航。</p>
            <p class="btns">
                <span class="btn ok" @click="handlerNext('second')">下一步</span>
            </p>
        </div>
        <div
            v-if="['second'].includes(guideStep)"
            class="guide-step">
            <p class="img"><img :src="$images.guide.second" alt="img"></p>
            <div class="content">
                <p>右侧是编辑器功能区</p>
                <p>也可以叫它素材库，包含图片、动画、游戏、题库等等</p>
                <p>我们会不停更新素材</p>
                <p>您也可以个性化上传哦~</p>
            </div>
            <p class="btns">
                <span class="btn ok" @click="handlerNext('third')">下一步</span>
            </p>
        </div>
        <div
            v-if="['third'].includes(guideStep)"
            class="guide-step">
            <p class="img"><img :src="$images.guide.third" alt="img"></p>
            <div class="content">
                <p>中间区域是编辑器的画布区。</p>
                <p>我们日常课件制作都是在画布区完成。</p>
            </div>
            <p class="btns">
                <span class="btn ok" @click="handlerNext('four')">下一步</span>
            </p>
        </div>
        <div
            v-if="['four'].includes(guideStep)"
            class="guide-step">
            <div class="content">
                <p>顶部是标题栏。</p>
                <p>在这里，我们可以修改课件的名称和标题。</p>
                <p>同时保存、预览、发布...所制作的课件。</p>
            </div>
            <p class="btns">
                <span class="btn ok" @click="handlerNext('five')">下一步</span>
            </p>
        </div>
        <div
            v-if="['five'].includes(guideStep)"
            class="guide-step">
            <p class="img"><img :src="$images.guide.five" alt="img"></p>
            <div class="content">
                <p>OK！老师您已经完成了本次引导，谢谢您的耐心体验。</p>
            </div>
            <p class="btns">
                <span class="btn ok" @click="handlerNext('done')">好的，下次再见</span>
            </p>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import LocalStorage from '../../../../utils/localStorageUtil'
    export default {
        name: "guide",
        computed: {
            ...mapState(['guideStep'])
        },
        methods: {
            handlerDone(){
                this.$store.state.guideStep = 'done'
                this.setGuideDone()
            },
            handlerNext(value){
                this.$store.state.guideStep = value
                if(value === 'done'){
                    this.setGuideDone()
                }
            },
            setGuideDone(){
                LocalStorage.setGuideStep('done')
            }
        }
    }
</script>

<style lang="scss" scoped>
.guide-box{
    width: 280px;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: relative;
    z-index: 10000001;

    .guide-step {
        .img{
            display: flex;
            align-items: center;
            justify-content: center;

            &>img{
                max-width: 100%;
            }
        }
    }

    .angle{
        position: absolute;
        top: 20px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;


        &.left{
            left: -10px;
            border-right: 11px solid white;
        }


        &.right{
            right: -10px;
            border-left: 11px solid white;
        }
    }

    &.first{
        position: absolute;
        top: 83px;
        left: 260px;
    }

    &.second{
        position: absolute;
        top: 90px;
        right: 98px;
    }

    &.four{
        position: absolute;
        top: 70px;
        right: 200px;
    }

    .img{
        width: 280px;
        height: 187px;
        background: #F5FAFF;
        margin-bottom: 16px;
    }

    .content{
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        line-height: 24px;
        margin-bottom: 24px;
    }
    .btns{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .btn{
            cursor: pointer;
            margin-left: 36px;
        }

        .ignore{
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            line-height: 14px;
        }
        .ok{
            text-align: center;
            min-width: 73px;
            height: 40px;
            line-height: 40px;
            padding: 0px 20px;
            background: #FF7838;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
</style>
